import React, { useState } from 'react'
import { Grid, AppLayout, NavigationHeader } from 'lib/components'
import { ManageUsers } from '../components'

export const ManageUsersScreen: React.FunctionComponent = () => {
    const [query, setQuery] = useState<string>()

    return (
        <AppLayout>
            <Grid.Background
                hasPaddingHorizontal
                hasPaddingVertical
            >
                <NavigationHeader/>
                <ManageUsers
                    setQuery={setQuery}
                    query={query}
                />
            </Grid.Background>
        </AppLayout>
    )
}
